export enum TelehealthStepsEnum {
  BrowserError = 'berror',
  EndedSession = 'esession',
  FullRoom = 'froom',
  GuestCredentials = 'gcredentials',
  Readiness = 'readiness',
  Session = 'session',
  FeedbackAdditional = 'afeedback',
  FeedbackNegativeAdditional = 'nfeedback',
  FeedbackSuccess = 'sfeedback',
  RedirectingZoom = 'Redirecting-zoom',
}

export enum FeedbackEnum {
  Negative = 'negative',
  Positive = 'positive',
  None = 'none',
}

export enum RoomEvents {
  Disconnected = 'disconnected',
  DominantSpeakerChanged = 'dominantSpeakerChanged',
  ParticipantConnected = 'participantConnected',
  ParticipantDisconnected = 'participantDisconnected',
  Reconnected = 'reconnected',
  Reconnecting = 'reconnecting',
  TrackPublished = 'trackPublished',
  TrackUnpublished = 'trackUnpublished',
}

export enum RoomStatuses {
  Connected = 'connected',
  Disconnected = 'disconnected',
  Reconnecting = 'reconnecting',
}

export enum LocalParticipantEvents {
  TrackPublicationFailed = 'trackPublicationFailed',
  TrackPublished = 'trackPublished',
  TrackUnpublished = 'trackUnpublished',
}

export enum ParticipantEvents {
  TrackPublicationFailed = 'trackPublicationFailed',
  TrackPublished = 'trackPublished',
  TrackUnpublished = 'trackUnpublished',
}

export enum PublicationEvents {
  Subscribed = 'subscribed',
  Unsubscribed = 'Unsubscribed',
}

export enum TrackEvents {
  Disabled = 'disabled',
  Enabled = 'enabled',
  Started = 'started',
  SwitchedOff = 'switchedOff',
  SwitchedOn = 'switchedOn',
}

export enum TrackKind {
  Audio = 'audio',
  Video = 'video',
  Data = 'data',
}
